import { SkeletonButton, SkeletonPageHeader, SkeletonPanel, SkeletonRect, SkeletonTable, SkeletonText } from '../Skeleton';

// =============================================================================
// BRICK management > Organization admin skeletons.
// Includes both the list view and the detail view.
// =============================================================================

export function OrgAdminListSkeleton(): JSX.Element {
  return (
    <div className="h-full overflow-auto p-6">
      <SkeletonPageHeader className="mb-6" />

      <div className="mb-4 flex items-end gap-4">
        <div className="flex flex-col gap-1">
          <SkeletonText width={40} height="0.85em" />
          <SkeletonRect width={180} height={38} />
        </div>
        <div className="flex flex-col gap-1">
          <SkeletonText width={40} height="0.85em" />
          <SkeletonRect width={180} height={38} />
        </div>
      </div>

      <div className="mb-3 flex items-center justify-between">
        <SkeletonText width={80} height="1em" />
        <div className="flex items-center gap-2">
          <SkeletonButton width={110} height={34} />
          <SkeletonRect width={220} height={34} />
        </div>
      </div>

      <SkeletonPanel header={false} className="overflow-hidden">
        <SkeletonTable
          rowCount={6}
          columns={[
            { label: '조직명', width: '22%' },
            { label: '권한', width: '12%' },
            { label: '등록된 관리자 수', width: '14%' },
            { label: '등록된 디바이스 수', width: '14%' },
            { label: '조직 등록일', width: '15%' },
            { label: '마지막 접속일', width: '15%' },
            { width: '8%' },
          ]}
        />
      </SkeletonPanel>

      <div className="mt-3 flex justify-end gap-1">
        {Array.from({ length: 7 }).map((_, i) => (
          <SkeletonRect key={i} width={32} height={30} />
        ))}
      </div>
    </div>
  );
}

export function OrgAdminDetailSkeleton(): JSX.Element {
  return (
    <div className="h-full overflow-auto p-6 pb-12">
      <SkeletonPageHeader className="mb-6" />

      {/* Organization info card */}
      <SkeletonPanel header className="mb-6">
        <div className="grid grid-cols-1 gap-4 p-5 sm:grid-cols-2">
          {Array.from({ length: 5 }).map((_, i) => (
            <div key={i} className="flex flex-col gap-1">
              <SkeletonText width={60} height="0.85em" />
              <SkeletonText width={160} height="1.1em" />
            </div>
          ))}
        </div>
      </SkeletonPanel>

      {/* Admin info table */}
      <SkeletonPanel header>
        <div className="p-5">
          <div className="mb-3 flex items-center justify-between">
            <SkeletonText width={80} height="1em" />
            <div className="flex items-center gap-2">
              <SkeletonButton width={120} height={34} />
              <SkeletonRect width={200} height={34} />
            </div>
          </div>
          <SkeletonTable
            rowCount={5}
            columns={[
              { label: '관리자명', width: '16%' },
              { label: '아이디', width: '16%' },
              { label: '연락처', width: '16%' },
              { label: '이메일', width: '24%' },
              { label: '마지막 접속일', width: '18%' },
              { width: '10%' },
            ]}
          />
          <div className="mt-3 flex justify-end gap-1">
            {Array.from({ length: 7 }).map((_, i) => (
              <SkeletonRect key={i} width={32} height={30} />
            ))}
          </div>
        </div>
      </SkeletonPanel>
    </div>
  );
}
